/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

import { PageViewElement } from '../page-view-element.js';
import { WakeLock } from '../../services/wake-lock.js';
import { ASYNC_PAUSE } from '../../utilities/constants.js';

export class WakePageViewElement extends PageViewElement {
  set active(val) {
    const oldVal = this._active;
    this._active = val;
    this.requestUpdate('active', oldVal);

    if (val) {
      // enable after other WakePageViewElements disable
      setTimeout(() => {
        WakeLock.enable();
      }, ASYNC_PAUSE);
    } else {
      WakeLock.disable();
    }
  }

  get active() {
    return this._active;
  }

  constructor() {
		super();
    this._active = false;
  }
}
